import React, { useState } from 'react'
import type { MenuProps } from 'antd'
import { Dropdown, Button, Radio, Space } from 'antd'
import { CaretDownOutlined, CaretUpOutlined, FilterOutlined } from '@ant-design/icons'

type FilterOption = {
    value: string
    label: string
}

const FilterDropdown: React.FC = () => {
    const [selectedValue, setSelectedValue] = useState<string | null>(null)
    const [visible, setVisible] = useState<boolean>(false)

    const options: FilterOption[] = []

    const handleVisibleChange = (flag: boolean) => {
        setVisible(flag)
    }

    const handleChange = (e: any) => {
        setSelectedValue(e.target.value)
        setVisible(false)
    }

    const items: MenuProps['items'] = [
        {
            label: (
                <Radio.Group onChange={handleChange} value={selectedValue}>
                    <Space direction="vertical">
                        {options.map((option) => (
                            <Radio key={option.value} value={option.value}>
                                {option.label}
                            </Radio>
                        ))}
                    </Space>
                </Radio.Group>
            ),
            key: 'radio-group'
        }
    ]

    return (
        <Dropdown menu={{ items }} trigger={['click']} open={visible} onOpenChange={handleVisibleChange}>
            <Button
                iconPosition={'end'}
                style={{ backgroundColor: '#F0F3F5', border: 'none', boxShadow: 'none', borderRadius: 10 }}
                icon={visible ? <CaretUpOutlined /> : <CaretDownOutlined />}
            >
                <FilterOutlined />
            </Button>
        </Dropdown>
    )
}

export default FilterDropdown
